import {ChangeDetectionStrategy,Component,DestroyRef,inject,input,LOCALE_ID} from '@angular/core';
import {MatDrawer} from '@angular/material/sidenav';
import {AppService} from '../../../app.service';
import {MATERIAL_IMPORTS} from '../../../shared/material-imports';
import {COMMON_IMPORTS} from '../../../shared/common-imports';
import {environment} from '../../../../environments/environment';
import {BreakpointObserver,Breakpoints} from '@angular/cdk/layout';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {AuthenticationService} from '../../../authentication/authentication.service';
import {DOCUMENT} from '@angular/common';
import {CUSTOM_BREAKPOINT} from '../../../common/enums/custom-breakpoint.enum';
import {CookieService} from 'ngx-cookie-service';

@Component({
	selector:'app-drawer',
	changeDetection:ChangeDetectionStrategy.OnPush,
	imports:[
		...MATERIAL_IMPORTS,
		...COMMON_IMPORTS
	],
	templateUrl:'./drawer.html',
	styleUrl:'./drawer.scss'
})
export class DrawerComponent{
	drawer=input.required<MatDrawer>();
	document=inject(DOCUMENT);
	destroyRef=inject(DestroyRef);
	breakpointObserver=inject(BreakpointObserver);
	appService=inject(AppService);
	authenticationService=inject(AuthenticationService);
	private readonly localeId=inject(LOCALE_ID);
	private readonly cookieService=inject(CookieService);
	protected readonly environment=environment;
	isXSmallWindow=this.breakpointObserver.observe([Breakpoints.XSmall,Breakpoints.Small])
	.pipe(
		takeUntilDestroyed(this.destroyRef)
	);
	isXXSmallWindow=this.breakpointObserver.observe([CUSTOM_BREAKPOINT.XXSmall])
	.pipe(
		takeUntilDestroyed(this.destroyRef)
	);

	get currentLocale():string{
		return this.localeId;
	}

	switchTo(locale:string):void{
		if(locale===this.localeId) return;
		// Remembered server-side on the next visit: the SSR locale redirect reads
		// this cookie ahead of the Accept-Language header.
		this.cookieService.set('locale',locale,{path:'/',expires:365,sameSite:'Lax'});
		const {pathname,search,hash}=this.document.location;
		const localePathRegex=new RegExp(`^/(es|en)(/|$)`);
		const newPath=localePathRegex.test(pathname)
			? pathname.replace(localePathRegex,`/${locale}$2`)
			: `/${locale}${pathname}`;
		this.document.location.href=`${newPath}${search}${hash}`;
	}

}
